import { Brand } from 'api/brand/fetchBrandById';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getLargestResolutionImageUrl } from 'utils/data/uriMediasObject/getLargestResolutionImageUrl';

interface PromotersCardProps {
  readonly promoterBrand: Brand | undefined;
  readonly withBorder?: boolean;
}

function PromotersCard({
  promoterBrand,
  withBorder = false,
}: PromotersCardProps) {
  const { t } = useTranslation();

  const logoUrl = getLargestResolutionImageUrl(promoterBrand?.logo?.uri);

  if (!promoterBrand || !promoterBrand?.name) {
    return null;
  }

  return (
    <Wrapper
      className="in-partnership-with"
      style={
        withBorder
          ? {
              border: '0.5px solid var(--way-colors-borderColor)',
              marginTop: '24px',
              marginBottom: '24px',
            }
          : {
              padding: 0,
              minWidth: '110px',
            }
      }
    >
      <Title>{t('inPartnershipWith')}</Title>
      {promoterBrand?.logoUrl ? (
        <img
          src={logoUrl}
          alt={`${promoterBrand.name} logo`}
          style={{
            display: 'block',
            margin: 'auto',
            maxHeight: '60px',
            objectFit: 'contain',
          }}
          title={promoterBrand?.name ?? ''}
        />
      ) : (
        <BrandName>{promoterBrand.name}</BrandName>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 8px;
  margin-top: 0px;
  margin-bottom: 0px;
`;

const Title = styled.h3`
  color: #636363;
  font-size: 14px;
  text-align: center;
  font-family: ${({ theme }) => theme.font.primaryFont};
  font-weight: 400;
  margin-bottom: 5px;
`;

const BrandName = styled.p`
  color: #000;
  font-size: 18px;
  text-align: center;
  font-family: ${({ theme }) => theme.font.primaryFont};
  font-weight: 500;
`;

export default PromotersCard;
